import { login, allUsers, userDetails, signup } from '@/services/userService';
import { getSingle, update } from '../services/customerService';
import { allLoans, loanUpdate, loanDetails, loanApproval, loanReasons, loanTypes, disburse, redFlag, repaymentUpdate } from '@/services/loanService';

function handleError(commit, error) {
    const message = error.message === 'Unauthorized' ? "Invalid email or password." : "Unavailable. Try again";
    commit('setError', message);
};

export default {
    async login({commit, state}, payload) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'form', value: true});
            const { data } = await login(payload);
            commit('setUser', data.user);
            commit('setUserRoles', data.roles);
            commit('setUserPermissions', data.permissions);
            localStorage.setItem('jwt', data.access_token)
            return true;
        } catch (error) {
            handleError(commit, error.response.data)
        } finally {
            commit('setLoading', {type: 'form', value: false});
        }
    },
    async getCustomer({commit, state}, id) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'body', value: true});
            const { data } = await getSingle(id);
            commit('setCustomer', data.user);
            return true;
        } catch (error) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'body', value: false});
        }
    },
    async updateCustomer({commit, state}, payload) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'form', value: true});
            const { data } = await update(payload);
            commit('setCustomer', data.user);
            return true;
        } catch (error) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'form', value: false});
        }
    },
    async getAllCustomers({commit, state}) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'body', value: true});
            const { data } = await allUsers();
            console.log(data);
            // const users = data.datas.filter(customers => customers.roles[0].name === "customer");
            // const active = users.filter(customer => customer.is_active === 1);
            // const inactive = users.filter(customer => customer.is_active === 0);
            // const active_customers = active.map(customer => customer.customer);
            // const inactive_customers = inactive.map(customer => customer.customer);
            // commit('setCustomers', {type: 'active', data: active_customers});
            // commit('setCustomers', {type: 'inactive', data: inactive_customers});
        } catch (error) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'body', value: false});
        }
    },
    async getAllLoans({commit, state}, type) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'body', value: true});
            const { data: { datas } } = await allLoans();
            if (type === 'approved') {
                let data = datas.filter(loans => loans.loan_status_id === 2);
                const loans = data.reverse();
                commit('setApprovedLoans', loans);
                return;
            }
            if (type === 'disburse') {
                const loans = datas.filter(loans => loans.loan_status_id === 4);
                commit('setDisbursedLoans', loans);
                return;
            }
            if (type === 'pending') {
                let data = datas.filter(loans => loans.loan_status_id === 1);
                const loans = data.reverse();
                commit('setPendingLoans', loans);
                return;
            }
            if (type === 'declined') {
                const loans = datas.filter(loans => loans.loan_status_id === 6);
                commit('setDeclinedLoans', loans);
                return;
            }
            if (type === 'disbursed') {
                const loans = datas.filter(loans => loans.loan_status_id === 5);
                commit('setActiveLoans', loans);
                return;
            }
            if (type === 'all') {
                commit('setLoans', datas);
                return;
            }
        } catch (error) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'body', value: false});
        }
    },
    async getLoanDetails({commit, state}, id) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'body', value: true});
            const { data: { loan } } = await loanDetails(id);
            commit('setLoanDetails', loan);
        } catch (error) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'body', value: false});
        }
    },
    async updateLoan({commit, state}, payload) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'body', value: true});
            const { data } = await loanUpdate(payload.payload, payload.id);
            return true;
        } catch (error) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'body', value: false});
        }
    },
    async getLoanTypes({commit, state}) {
        try {
            const { data: { datas } } = await loanTypes();
            commit('setLoanTypes', datas);
        } catch (error) {
            handleError(commit, error);
        } finally {}
    },
    async getLoanReasons({commit, state}) {
        try {
            const { data: { datas } } = await loanReasons();
            commit('setLoanReasons', datas);
        } catch (error) {
            handleError(commit, error);
        } finally {}
    },
    async getUserDetails({commit, state}, payload) {
        try {
            payload.loading ? commit('setLoading', {type: 'body', value: true}) : "";
            const { data: { user } } = await userDetails(payload.id);
            commit('setUserDetails', user);
            commit('setCustomer', user.customer);
        } catch (error) {
            handleError(commit, error);
        } finally {
            payload.loading ? commit('setLoading', {type: 'body', value: false}) : "";
        }
    },
    async approveLoan({commit, state}, payload) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'body', value: true});
            await loanApproval(payload.status, payload.id);
            return true;
        } catch (error) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'body', value: false});
        }
    },
    async disburseLoan({commit, dispatch}, id) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'body', value: true});
            await disburse(id);
            dispatch('approveLoan', {status: 5, id: id});
            return true;
        } catch (error) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'body', value: false});
        }
    },
    async getRedflag({commit, state}, user_id) {
        try {
            commit('setError', '');
            commit('setLoading', {type: 'body', value: true});
            const { data: {redflags}} = await redFlag(user_id);
            commit('setRedflag', redflags);
        } catch (err) {
            handleError(commit, error);
        } finally {
            commit('setLoading', {type: 'body', value: false});
        }
    },
    async createUser({commit, state}, payload) {
        try {
            commit('setError','');
            const data = await signup(payload);
            console.log(JSON.stringify(data));
            return true;
        }
        catch(err) {
            console.log(err);
            return false;
        }
    },
    async updateRepayment({commit, state}, payload) {
        try {
            commit('setError','');
            const data = await repaymentUpdate(payload.key,payload.loan_id);
            console.log(data);
            return true;
        } catch(err) {
            return false;
        }
    }
}